// Centralized i18n translations for PingMe by Tagora
// Defaults are used as fallback. Admin can override via backoffice upload/edit.

const RAW_BACKEND = process.env.REACT_APP_BACKEND_URL || '';
// Trim trailing slash to avoid `//translations/...` double-slash bugs when
// the env variable is configured with a trailing `/` in production.
const API = `${RAW_BACKEND.replace(/\/+$/, '')}/api`;

const defaultTranslations = {
  fr: {
    categories: {
      keys: 'Cles',
      phone: 'Telephone & electronique',
      bag: 'Sac & bagage',
      clothing: 'Vetements',
      child: 'Objets enfants & doudou',
      pet: 'Animaux',
      bike: 'Velo & mobilite',
      car: 'Voiture',
      valuables: 'Objets de valeur',
      accessories: 'Accessoires du quotidien',
      home: 'Maison & loisirs',
      // Backwards compatibility (older PingMes)
      doudou: 'Objets enfants & doudou', wallet: 'Objets de valeur', other: 'Accessoires du quotidien',
      stickers: 'Stickers', keychains: 'Porte-cles', pet_tags: 'Medailles Animal',
      bracelets: 'Bracelets', car_stickers: 'Auto', luggage: 'Sac & bagage',
    },
    nav: {
      shop: 'Boutique', business: 'Entreprises', lost: 'Objets Perdus',
      dashboard: 'Dashboard', messages: 'Messages', account: 'Mon compte',
      admin: 'Backoffice', login: 'Connexion', register: "S'inscrire", logout: 'Deconnexion',
    },
    actions: {
      save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer', edit: 'Modifier',
      add: 'Ajouter', create: 'Creer', confirm: 'Confirmer', close: 'Fermer',
      send: 'Envoyer', reply: 'Repondre', block: 'Bloquer', unblock: 'Debloquer',
      report: 'Signaler', download: 'Telecharger', back: 'Retour', search: 'Rechercher',
      seeMore: 'Voir plus', print: 'Imprimer', share: 'Partager',
    },
    header: { switchLang: 'English' },
    landing: {
      badge: 'Standard Tagora ID',
      heroTitle: 'Retrouvez ce qui',
      heroHighlight: 'compte pour vous',
      heroDesc: "Un PingMe sur chaque objet. Quelqu'un le trouve ? Il vous contacte en 1 scan, sans connaitre votre identite. Simple, securise, anonyme.",
      heroCta: 'Je protege mes objets',
      heroCtaShop: 'Voir la boutique',
      statsLabel: 'objets retrouves',
      statsMonth: 'ce mois-ci',
      marquee: 'RETROUVEZ CE QUI COMPTE * 100% ANONYME * 1 SCAN SUFFIT * MESSAGERIE SECURISEE * RECOMPENSE INTEGREE *',
      useCasesTag: "CAS D'USAGE",
      useCasesTitle: 'Un PingMe pour chaque situation',
      useCasesDesc: "De vos cles a votre animal, chaque objet merite d'etre protege.",
      howTag: 'COMMENT CA MARCHE',
      howTitle: 'Simple comme 1, 2, 3',
      step01Title: 'Creez votre PingMe', step01Desc: 'Inscrivez-vous et creez un QR code unique pour votre objet',
      step02Title: 'Collez-le', step02Desc: 'Imprimez ou achetez un sticker dans notre boutique',
      step03Title: 'Dormez tranquille', step03Desc: "Si quelqu'un trouve votre objet, il vous contacte en 1 scan",
      featuresTag: 'FONCTIONNALITES',
      featuresTitle: "Tout ce qu'il faut pour retrouver vos objets",
      feat1Title: '100% Anonyme', feat1Desc: 'Vos coordonnees ne sont jamais partagees',
      feat2Title: 'Messagerie relayee', feat2Desc: 'Communiquez sans reveler votre identite',
      feat3Title: 'Recompense integree', feat3Desc: 'Proposez une recompense pour motiver le retour',
      feat4Title: 'Standard mondial', feat4Desc: 'Identifiant Tagora ID universel verifie hors-ligne',
      ctaTitle: 'Pret a proteger vos objets ?',
      ctaDesc: "Rejoignez des milliers d'utilisateurs qui ne perdent plus rien.",
      ctaBtn: 'Commencer gratuitement',
      footerHelp: 'Aide', footerPrivacy: 'Confidentialite', footerTerms: 'CGU',
    },
    dashboard: {
      myPingmes: 'Mes PingMe', organizations: 'Organisations',
      noPingmes: 'Aucun PingMe', noPingmesInCategory: 'Aucun PingMe dans',
      createPingme: 'Nouveau PingMe', editPingme: 'Modifier le PingMe',
      lost: 'Perdu', found: 'Retrouve', scans: 'scans',
      reward: 'Recompense', active: 'Actif', inactive: 'Inactif',
      allCategories: 'Tous', totalPingmes: 'Total PingMe',
      urgentMode: 'Mode Urgent', declareUrgent: 'Declarer urgence',
      cancelUrgent: 'Annuler urgence',
      name: 'Nom', description: 'Description', category: 'Categorie',
      photo: 'Photo', rewardAmount: 'Recompense (EUR)', activeDays: 'Actif pendant (jours)',
      labelText: "Texte de l'etiquette", presetMessage: 'Message pre-enregistre',
      presetModeBefore: 'Afficher avant la conversation',
      presetModeOnly: 'Afficher uniquement (pas de conversation)',
      unlimited: 'Illimite',
      objectType: "Type d'objet", lastLocation: 'Derniere localisation',
      rewardOffer: 'Recompense offerte', urgentDesc: 'Description',
      urgentDeclareBtn: 'Declarer la perte urgente',
      createOrg: 'Creer une organisation', orgName: "Nom de l'organisation",
      useCase: "Cas d'utilisation", addMember: 'Ajouter un membre',
      memberEmail: 'Email du membre', memberRole: 'Role',
      members: 'Membres', inviteLink: "Lien d'invitation",
      pingmesInOrg: "PingMe de l'organisation", noPingmesInOrg: 'Aucun PingMe',
      removePingme: 'Retirer', addToOrg: "Ajouter a l'organisation",
      notifPrefs: 'Preferences de notification',
      useAccountDefaults: 'Utiliser les preferences du compte',
    },
    messages: {
      myPingmes: 'Mes PingMe', foundObjects: 'Objets trouves',
      noConversation: 'Aucune conversation',
      scanToStart: 'Scannez un QR PingMe pour demarrer',
      selectPingme: 'Selectionnez un PingMe puis une conversation',
      selectConversation: 'Selectionnez une conversation',
      activeConversations: 'Conversations actives',
      conversationWith: 'Conversation avec',
      asFinderLabel: 'Conversation en tant que trouveur',
      blocked: 'Conversation bloquee', blockedByOwner: 'Le proprietaire a bloque cette conversation',
      waitingReply: 'En attente de la reponse du proprietaire...',
      replyPlaceholder: 'Repondre...', yourReply: 'Votre reponse...',
      noMessages: 'Aucun message pour le moment',
      expired: 'Expire', reported: 'Signale',
      phoneShared: 'Numero du proprietaire',
      followFromAccount: 'Suivre cette conversation depuis mon compte',
      followShort: 'Suivre depuis mon compte',
      loginToFollow: 'Connectez-vous pour suivre cette conversation depuis votre compte',
      backToDashboard: 'Retour au Dashboard',
      messageSent: 'Message envoye! Le proprietaire recevra votre message.',
      sharePhone: 'Partager mon numero', removeShare: 'Retirer le partage du numero',
      messagingDisabled: 'La messagerie est actuellement desactivee.',
    },
    notifications: {
      title: 'Notifications', empty: 'Aucune notification',
      viewAllMessages: 'Voir tous les messages', now: 'maintenant',
    },
    shop: {
      tag: 'BOUTIQUE', title: 'Goodies PingMe',
      subtitle: 'Stickers, porte-cles et accessoires avec QR code integre',
      cart: 'Panier', addToCart: '+ Ajouter', emptyCart: 'Votre panier est vide',
      suggest: 'Suggerer un produit', suggestTitle: 'Suggerer un produit',
      suggestPlaceholder: 'Decrivez le produit que vous aimeriez voir...',
      suggestEmail: 'Votre email (optionnel)', suggestSend: 'Envoyer la suggestion',
      freeShipping: "Livraison gratuite des 50EUR d'achat!",
      checkout: 'Commander', total: 'Total', shipping: 'Livraison',
      shippingAddress: 'Adresse de livraison',
      street: 'Rue', city: 'Ville', postalCode: 'Code postal', country: 'Pays',
      calculateShipping: 'Calculer les frais', pay: 'Payer',
      orderConfirm: 'Commande confirmee!',
      productCategories: {
        stickers: 'Stickers', keychains: 'Porte-cles', pet_tags: 'Medailles Animal',
        bracelets: 'Bracelets', car_stickers: 'Auto', luggage: 'Bagages', doudou: 'Doudou',
      },
    },
    account: {
      title: 'Mon Compte',
      profile: 'Profil', notifications: 'Notifications', security: 'Securite', orders: 'Commandes',
      fullName: 'Nom complet', email: 'Email', phone: 'Telephone',
      saveProfile: 'Enregistrer les modifications',
      notifTitle: 'Notifications', notifDesc: 'Choisissez comment recevoir vos alertes',
      emailNotif: 'Email', emailNotifDesc: 'Recevoir un email a',
      smsNotif: 'SMS', smsNotifDescWithPhone: 'Recevoir un SMS au',
      smsNotifDescNoPhone: 'Ajoutez un numero de telephone dans votre profil',
      pushNotif: 'Notification push', pushNotifDesc: 'Recevoir une notification dans le navigateur',
      pushNotSupported: 'Non supporte par ce navigateur',
      currentPassword: 'Mot de passe actuel', newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe', changePassword: 'Changer le mot de passe',
      noOrders: 'Aucune commande',
      orderStatus: { pending: 'En attente', processing: 'En cours', shipped: 'Expediee', delivered: 'Livree', cancelled: 'Annulee' },
    },
    lost: {
      tag: 'CARTE COMMUNAUTAIRE', title: 'Objets Perdus',
      subtitle: 'Aidez a retrouver des objets perdus pres de chez vous',
      allCategories: 'Toutes', listView: 'Liste', mapView: 'Carte',
      urgent: 'URGENT', contactOwner: 'Contacter le proprietaire',
      reward: 'Recompense', noLostObjects: 'Aucun objet perdu signale',
      noLostObjectsDesc: 'Bonne nouvelle ! Aucun objet perdu pour le moment.',
      urgentOnly: 'Urgents uniquement', objectsCount: 'objets perdus',
    },
    ping: {
      scanTitle: 'PingMe scanne!', ownerContacted: 'Le proprietaire sera contacte',
      sendMessage: 'Envoyer un message au proprietaire',
      yourName: 'Votre nom (optionnel)', yourMessage: 'Votre message...',
      send: 'Envoyer', presetMsgLabel: 'Message du proprietaire',
      conversationExpires: 'La conversation expire dans', hours: 'heures',
      yourLocation: 'Votre localisation a ete partagee',
      claimTitle: 'Revendiquer ce PingMe', claimDesc: 'Si cet objet vous appartient',
      claimBtn: 'Revendiquer', inactive: 'Ce PingMe est actuellement inactif.',
      ownerInfo: 'Proprietaire prevenu', rewardOffered: 'Recompense offerte',
    },
    business: {
      heroTag: 'ENTREPRISES & ORGANISATIONS',
      heroTitle: 'Protegez les actifs de votre', heroHighlight: 'organisation',
      heroDesc: "PingMe Entreprise permet de gerer et proteger les biens de votre organisation avec des QR codes intelligents.",
      heroCta: 'Commencer gratuitement', heroCtaDemo: 'Demander une demo',
      useCasesTag: 'SOLUTIONS SECTORIELLES', useCasesTitle: 'Adapte a chaque secteur',
      useCasesDesc: "Des solutions sur mesure pour chaque type d'organisation.",
      faqTag: 'FAQ', faqTitle: 'Questions frequentes',
      contactTag: 'CONTACT', contactTitle: 'Parlons de votre projet',
      contactDesc: 'Remplissez le formulaire et notre equipe vous recontactera sous 24h.',
      contactName: 'Nom complet', contactEmail: 'Email professionnel',
      contactCompany: 'Entreprise', contactPhone: 'Telephone',
      contactEmployees: "Nombre d'employes", contactMessage: 'Votre message',
      contactSend: 'Envoyer la demande',
      // Default use cases
      uc1Title: 'Flottes de vehicules', uc1Desc: 'Suivez vos vehicules et equipements professionnels.', uc1Stats: '87% de reduction des pertes',
      uc2Title: 'Ecoles et creches', uc2Desc: 'Securisez les affaires des enfants lors des sorties scolaires.', uc2Stats: '95% de satisfaction parents',
      uc3Title: 'Hotels et residences', uc3Desc: 'Retrouvez les objets oublies par vos clients.', uc3Stats: '3x plus de retours',
      uc4Title: 'Entreprises', uc4Desc: 'Gerez le materiel de vos equipes.', uc4Stats: '60% de temps gagne',
      // Features
      feat1Title: 'QR codes illimites', feat1Desc: 'Generez autant de PingMes que necessaire pour tous vos actifs.',
      feat2Title: "Gestion d'equipe", feat2Desc: 'Ajoutez des membres, definissez des roles et gerez les acces.',
      feat3Title: 'Analytics en temps reel', feat3Desc: "Suivez les scans, les retours et l'activite de vos PingMes.",
      feat4Title: 'Securite enterprise', feat4Desc: 'TLS 1.3, RGPD, audit logs et SSO disponibles.',
      feat5Title: 'Support dedie', feat5Desc: 'Un interlocuteur dedie pour vous accompagner a chaque etape.',
      feat6Title: 'API & Integrations', feat6Desc: 'Integrez Tagora a vos outils existants via notre API REST.',
      // Badges & extra
      badge1: '100% RGPD', badge2: 'Communications anonymes', badge3: 'Deploiement mondial', badge4: 'Setup en 24h',
      requestDemo: 'Demander une demo', requestDemoFree: 'Demander une demo gratuite',
    },
    auth: {
      loginTitle: 'Connexion', registerTitle: 'Inscription',
      email: 'Email', password: 'Mot de passe',
      loginBtn: 'Se connecter', registerBtn: 'Creer mon compte',
      orGoogle: 'Ou continuer avec Google', forgotPassword: 'Mot de passe oublie ?',
      noAccount: 'Pas encore de compte ?', hasAccount: 'Deja un compte ?',
      resetTitle: 'Reinitialiser le mot de passe',
      resetDesc: 'Entrez votre email pour recevoir un lien de reinitialisation.',
      resetBtn: 'Envoyer le lien', name: 'Nom complet',
      loginSubtitle: 'Accedez a votre espace PingMe',
      registerSubtitle: 'Rejoignez la communaute Tagora',
      or: 'ou',
    },
    status: { lost: 'PERDU', found: 'Retrouve', active: 'Actif', inactive: 'Inactif' },
  },

  en: {
    categories: {
      keys: 'Keys',
      phone: 'Phone & electronics',
      bag: 'Bag & luggage',
      clothing: 'Clothing',
      child: 'Kids & comfort items',
      pet: 'Pets',
      bike: 'Bike & mobility',
      car: 'Car',
      valuables: 'Valuables',
      accessories: 'Daily accessories',
      home: 'Home & leisure',
      // Backwards compatibility
      doudou: 'Kids & comfort items', wallet: 'Valuables', other: 'Daily accessories',
      stickers: 'Stickers', keychains: 'Keychains', pet_tags: 'Pet Tags',
      bracelets: 'Bracelets', car_stickers: 'Car', luggage: 'Luggage',
    },
    nav: {
      shop: 'Shop', business: 'Business', lost: 'Lost Objects',
      dashboard: 'Dashboard', messages: 'Messages', account: 'My Account',
      admin: 'Backoffice', login: 'Login', register: 'Sign Up', logout: 'Logout',
    },
    actions: {
      save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit',
      add: 'Add', create: 'Create', confirm: 'Confirm', close: 'Close',
      send: 'Send', reply: 'Reply', block: 'Block', unblock: 'Unblock',
      report: 'Report', download: 'Download', back: 'Back', search: 'Search',
      seeMore: 'See more', print: 'Print', share: 'Share',
    },
    header: { switchLang: 'Francais' },
    landing: {
      badge: 'Tagora ID standard',
      heroTitle: 'Find what', heroHighlight: 'matters to you',
      heroDesc: "A PingMe on every item. Someone finds it? They contact you in 1 scan, without knowing your identity. Simple, secure, anonymous.",
      heroCta: 'Protect my items', heroCtaShop: 'Visit the shop',
      statsLabel: 'items recovered', statsMonth: 'this month',
      marquee: 'FIND WHAT MATTERS * 100% ANONYMOUS * 1 SCAN IS ALL IT TAKES * SECURE MESSAGING * BUILT-IN REWARD *',
      useCasesTag: 'USE CASES', useCasesTitle: 'A PingMe for every situation',
      useCasesDesc: 'From your keys to your pet, every item deserves protection.',
      howTag: 'HOW IT WORKS', howTitle: 'Simple as 1, 2, 3',
      step01Title: 'Create your PingMe', step01Desc: 'Sign up and create a unique QR code for your item',
      step02Title: 'Stick it', step02Desc: 'Print or buy a sticker from our shop',
      step03Title: 'Sleep tight', step03Desc: 'If someone finds your item, they contact you in 1 scan',
      featuresTag: 'FEATURES', featuresTitle: 'Everything you need to recover your items',
      feat1Title: '100% Anonymous', feat1Desc: 'Your details are never shared',
      feat2Title: 'Relay Messaging', feat2Desc: 'Communicate without revealing your identity',
      feat3Title: 'Built-in Reward', feat3Desc: 'Offer a reward to motivate the return',
      feat4Title: 'Global standard', feat4Desc: 'Universal Tagora ID verified offline',
      ctaTitle: 'Ready to protect your items?',
      ctaDesc: 'Join thousands of users who never lose anything.',
      ctaBtn: 'Get started for free',
      footerHelp: 'Help', footerPrivacy: 'Privacy', footerTerms: 'Terms',
    },
    dashboard: {
      myPingmes: 'My PingMe', organizations: 'Organizations',
      noPingmes: 'No PingMe', noPingmesInCategory: 'No PingMe in',
      createPingme: 'New PingMe', editPingme: 'Edit PingMe',
      lost: 'Lost', found: 'Found', scans: 'scans',
      reward: 'Reward', active: 'Active', inactive: 'Inactive',
      allCategories: 'All', totalPingmes: 'Total PingMe',
      urgentMode: 'Urgent Mode', declareUrgent: 'Declare urgent',
      cancelUrgent: 'Cancel urgent',
      name: 'Name', description: 'Description', category: 'Category',
      photo: 'Photo', rewardAmount: 'Reward (EUR)', activeDays: 'Active for (days)',
      labelText: 'Label text', presetMessage: 'Preset message',
      presetModeBefore: 'Show before conversation', presetModeOnly: 'Show only (no conversation)',
      unlimited: 'Unlimited',
      objectType: 'Object type', lastLocation: 'Last location',
      rewardOffer: 'Reward offered', urgentDesc: 'Description',
      urgentDeclareBtn: 'Declare urgent loss',
      createOrg: 'Create organization', orgName: 'Organization name',
      useCase: 'Use case', addMember: 'Add member',
      memberEmail: 'Member email', memberRole: 'Role',
      members: 'Members', inviteLink: 'Invite link',
      pingmesInOrg: 'Organization PingMe', noPingmesInOrg: 'No PingMe',
      removePingme: 'Remove', addToOrg: 'Add to organization',
      notifPrefs: 'Notification preferences', useAccountDefaults: 'Use account defaults',
    },
    messages: {
      myPingmes: 'My PingMe', foundObjects: 'Found Objects',
      noConversation: 'No conversation', scanToStart: 'Scan a PingMe QR to start',
      selectPingme: 'Select a PingMe then a conversation',
      selectConversation: 'Select a conversation',
      activeConversations: 'Active conversations',
      conversationWith: 'Conversation with', asFinderLabel: 'Conversation as finder',
      blocked: 'Conversation blocked', blockedByOwner: 'Owner has blocked this conversation',
      waitingReply: "Waiting for the owner's reply...",
      replyPlaceholder: 'Reply...', yourReply: 'Your reply...',
      noMessages: 'No messages yet', expired: 'Expired', reported: 'Reported',
      phoneShared: 'Owner phone number',
      followFromAccount: 'Follow this conversation from my account',
      followShort: 'Follow from my account',
      loginToFollow: 'Log in to follow this conversation from your account',
      backToDashboard: 'Back to Dashboard',
      messageSent: 'Message sent! The owner will receive your message.',
      sharePhone: 'Share my number', removeShare: 'Remove number sharing',
      messagingDisabled: 'Messaging is currently disabled.',
    },
    notifications: {
      title: 'Notifications', empty: 'No notifications',
      viewAllMessages: 'View all messages', now: 'now',
    },
    shop: {
      tag: 'SHOP', title: 'PingMe Goodies',
      subtitle: 'Stickers, keychains and accessories with integrated QR code',
      cart: 'Cart', addToCart: '+ Add', emptyCart: 'Your cart is empty',
      suggest: 'Suggest a product', suggestTitle: 'Suggest a product',
      suggestPlaceholder: "Describe the product you'd like to see...",
      suggestEmail: 'Your email (optional)', suggestSend: 'Send suggestion',
      freeShipping: 'Free shipping from 50EUR!',
      checkout: 'Checkout', total: 'Total', shipping: 'Shipping',
      shippingAddress: 'Shipping address',
      street: 'Street', city: 'City', postalCode: 'Postal code', country: 'Country',
      calculateShipping: 'Calculate shipping', pay: 'Pay',
      orderConfirm: 'Order confirmed!',
      productCategories: {
        stickers: 'Stickers', keychains: 'Keychains', pet_tags: 'Pet Tags',
        bracelets: 'Bracelets', car_stickers: 'Car', luggage: 'Luggage', doudou: 'Stuffed Toy',
      },
    },
    account: {
      title: 'My Account',
      profile: 'Profile', notifications: 'Notifications', security: 'Security', orders: 'Orders',
      fullName: 'Full name', email: 'Email', phone: 'Phone',
      saveProfile: 'Save changes',
      notifTitle: 'Notifications', notifDesc: 'Choose how to receive your alerts',
      emailNotif: 'Email', emailNotifDesc: 'Receive an email at',
      smsNotif: 'SMS', smsNotifDescWithPhone: 'Receive a SMS at',
      smsNotifDescNoPhone: 'Add a phone number in your profile',
      pushNotif: 'Push notification', pushNotifDesc: 'Receive a notification in the browser',
      pushNotSupported: 'Not supported by this browser',
      currentPassword: 'Current password', newPassword: 'New password',
      confirmPassword: 'Confirm password', changePassword: 'Change password',
      noOrders: 'No orders',
      orderStatus: { pending: 'Pending', processing: 'Processing', shipped: 'Shipped', delivered: 'Delivered', cancelled: 'Cancelled' },
    },
    lost: {
      tag: 'COMMUNITY MAP', title: 'Lost Objects',
      subtitle: 'Help find lost objects near you',
      allCategories: 'All', listView: 'List', mapView: 'Map',
      urgent: 'URGENT', contactOwner: 'Contact owner',
      reward: 'Reward', noLostObjects: 'No lost objects reported',
      noLostObjectsDesc: 'Good news! No lost objects at the moment.',
      urgentOnly: 'Urgent only', objectsCount: 'lost objects',
    },
    ping: {
      scanTitle: 'PingMe scanned!', ownerContacted: 'The owner will be contacted',
      sendMessage: 'Send a message to the owner',
      yourName: 'Your name (optional)', yourMessage: 'Your message...',
      send: 'Send', presetMsgLabel: 'Owner message',
      conversationExpires: 'Conversation expires in', hours: 'hours',
      yourLocation: 'Your location has been shared',
      claimTitle: 'Claim this PingMe', claimDesc: 'If this item belongs to you',
      claimBtn: 'Claim', inactive: 'This PingMe is currently inactive.',
      ownerInfo: 'Owner notified', rewardOffered: 'Reward offered',
    },
    business: {
      heroTag: 'BUSINESS & ORGANIZATIONS',
      heroTitle: 'Protect your', heroHighlight: 'organization assets',
      heroDesc: "PingMe Business helps manage and protect your organization's assets with smart QR codes.",
      heroCta: 'Get started for free', heroCtaDemo: 'Request a demo',
      useCasesTag: 'INDUSTRY SOLUTIONS', useCasesTitle: 'Adapted to every sector',
      useCasesDesc: 'Tailored solutions for every type of organization.',
      faqTag: 'FAQ', faqTitle: 'Frequently asked questions',
      contactTag: 'CONTACT', contactTitle: "Let's discuss your project",
      contactDesc: 'Fill in the form and our team will get back to you within 24h.',
      contactName: 'Full name', contactEmail: 'Professional email',
      contactCompany: 'Company', contactPhone: 'Phone',
      contactEmployees: 'Number of employees', contactMessage: 'Your message',
      contactSend: 'Send request',
      uc1Title: 'Vehicle Fleets', uc1Desc: 'Track your vehicles and professional equipment.', uc1Stats: '87% loss reduction',
      uc2Title: 'Schools & Daycares', uc2Desc: "Secure children's belongings during school trips.", uc2Stats: '95% parent satisfaction',
      uc3Title: 'Hotels & Residences', uc3Desc: 'Recover items left by your guests.', uc3Stats: '3x more returns',
      uc4Title: 'Enterprises', uc4Desc: 'Manage your team equipment.', uc4Stats: '60% time saved',
      feat1Title: 'Unlimited QR codes', feat1Desc: 'Generate as many PingMes as you need for all your assets.',
      feat2Title: 'Team Management', feat2Desc: 'Add members, define roles and manage access.',
      feat3Title: 'Real-time Analytics', feat3Desc: 'Track scans, returns and activity of your PingMes.',
      feat4Title: 'Enterprise Security', feat4Desc: 'TLS 1.3, GDPR, audit logs and SSO available.',
      feat5Title: 'Dedicated Support', feat5Desc: 'A dedicated contact to guide you every step of the way.',
      feat6Title: 'API & Integrations', feat6Desc: 'Integrate Tagora with your existing tools via our REST API.',
      badge1: '100% GDPR', badge2: 'Anonymous communications', badge3: 'Global deployment', badge4: 'Setup in 24h',
      requestDemo: 'Request a demo', requestDemoFree: 'Request a free demo',
    },
    auth: {
      loginTitle: 'Login', registerTitle: 'Sign Up',
      email: 'Email', password: 'Password',
      loginBtn: 'Log in', registerBtn: 'Create my account',
      orGoogle: 'Or continue with Google', forgotPassword: 'Forgot password?',
      noAccount: 'No account yet?', hasAccount: 'Already have an account?',
      resetTitle: 'Reset password',
      resetDesc: 'Enter your email to receive a reset link.',
      resetBtn: 'Send link', name: 'Full name',
      loginSubtitle: 'Access your PingMe space',
      registerSubtitle: 'Join the Tagora community',
      or: 'or',
    },
    status: { lost: 'LOST', found: 'Found', active: 'Active', inactive: 'Inactive' },
  },
};

// Deep merge: override defaults with DB values
function deepMerge(target, source) {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key]) && target[key]) {
      result[key] = deepMerge(target[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
}

// Active translations (defaults + DB overrides)
let translations = { fr: { ...defaultTranslations.fr }, en: { ...defaultTranslations.en } };
let currentLang = localStorage.getItem('tagora_lang') || 'fr';
let loaded = false;

// Load translations from API and merge with defaults
export async function loadTranslations() {
  try {
    const safeJson = async (url) => {
      try {
        const r = await fetch(url, { headers: { 'Accept': 'application/json' } });
        if (!r.ok) return {};
        const ct = r.headers.get('content-type') || '';
        if (!ct.includes('application/json')) return {};
        return await r.json();
      } catch {
        return {};
      }
    };
    const [frRes, enRes] = await Promise.all([
      safeJson(`${API}/translations/fr`),
      safeJson(`${API}/translations/en`),
    ]);
    if (frRes && Object.keys(frRes).length > 0) {
      translations.fr = deepMerge(defaultTranslations.fr, frRes);
    }
    if (enRes && Object.keys(enRes).length > 0) {
      translations.en = deepMerge(defaultTranslations.en, enRes);
    }
    loaded = true;
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event('langchange'));
    }
  } catch {
    // Use defaults silently
  }
}

// Fire and forget on import
loadTranslations();

export const setLanguage = (lang) => {
  currentLang = lang;
  localStorage.setItem('tagora_lang', lang);
  window.dispatchEvent(new Event('langchange'));
};

export const getLanguage = () => currentLang;

export const t = (key) => {
  const keys = key.split('.');
  let value = translations[currentLang];
  for (const k of keys) {
    if (!value) return key;
    value = value[k];
  }
  return value || key;
};

// Return the default (untranslated/code-level) value for a key.
// Used to detect whether a translation has been customized by the admin.
export const tDefault = (key, lang = currentLang) => {
  const keys = key.split('.');
  let value = defaultTranslations[lang] || defaultTranslations.fr;
  for (const k of keys) {
    if (!value) return key;
    value = value[k];
  }
  return value || key;
};

// Returns true if the admin has customized this translation key (i.e. current
// value differs from the code-level default).
export const tIsCustomized = (key) => {
  const cur = t(key);
  const def = tDefault(key);
  return Boolean(cur) && cur !== key && cur !== def;
};

export const categoryLabel = (category) => {
  return translations[currentLang]?.categories?.[category] || category;
};

export const allCategories = new Proxy({}, {
  get: (_, prop) => {
    if (prop === Symbol.iterator || prop === 'length') return undefined;
    return translations[currentLang]?.categories?.[prop] || prop;
  },
  ownKeys: () => Object.keys(defaultTranslations.fr.categories),
  getOwnPropertyDescriptor: (_, prop) => {
    if (Object.keys(defaultTranslations.fr.categories).includes(prop)) {
      return { configurable: true, enumerable: true, value: translations[currentLang]?.categories?.[prop] || prop };
    }
  }
});

export const getFullTranslations = (lang) => translations[lang] || defaultTranslations[lang] || {};
export const getDefaultTranslations = (lang) => defaultTranslations[lang] || {};

export const availableLanguages = [
  { code: 'fr', label: 'Francais', flag: 'FR' },
  { code: 'en', label: 'English', flag: 'EN' },
];

export default translations;
